export default __webpack_public_path__ + "static/google-cloud-0d55c41d7ca5dfd1c21dae664609f49d.png";